// extracted by mini-css-extract-plugin
export default {"AgeCalculator":"AgeCalculator_AgeCalculator__Ca2MU"};